import { useState } from 'react';

// ─── Thai banks — clearbit domain gives the best logo match ─────────────────
export const BANKS = [
  { name: 'ธนาคารกสิกรไทย',         display: 'กสิกรไทย',          short: 'KBank',     bg: '#138f2d', text: '#fff', domain: 'kasikornbank.com' },
  { name: 'ธนาคารกรุงไทย',           display: 'กรุงไทย',           short: 'KTB',       bg: '#1ba3dc', text: '#fff', domain: 'ktb.co.th' },
  { name: 'ธนาคารไทยพาณิชย์',        display: 'ไทยพาณิชย์',       short: 'SCB',       bg: '#4e2d82', text: '#fff', domain: 'scb.co.th' },
  { name: 'ธนาคารกรุงเทพ',           display: 'กรุงเทพ',           short: 'BBL',       bg: '#1e3a6e', text: '#fff', domain: 'bangkokbank.com' },
  { name: 'ธนาคารทหารไทยธนชาต',      display: 'ทหารไทยธนชาต',    short: 'TTB',       bg: '#0067b1', text: '#fff', domain: 'ttb.co.th' },
  { name: 'ธนาคารกรุงศรีอยุธยา',     display: 'กรุงศรี',           short: 'BAY',       bg: '#ffc50a', text: '#333', domain: 'krungsri.com' },
  { name: 'ธนาคารออมสิน',            display: 'ออมสิน',            short: 'GSB',       bg: '#eb198d', text: '#fff', domain: 'gsb.or.th' },
  { name: 'ธนาคาร ธ.ก.ส.',           display: 'ธ.ก.ส.',            short: 'BAAC',      bg: '#4baf4f', text: '#fff', domain: 'baac.or.th' },
  { name: 'ธนาคารอาคารสงเคราะห์',    display: 'อาคารสงเคราะห์',   short: 'GHB',       bg: '#f4831f', text: '#fff', domain: 'ghbank.co.th' },
  { name: 'ธนาคารทิสโก้',            display: 'ทิสโก้',            short: 'TISCO',     bg: '#0080c3', text: '#fff', domain: 'tisco.co.th' },
  { name: 'ธนาคารเกียรตินาคินภัทร',  display: 'เกียรตินาคินภัทร', short: 'KKP',       bg: '#635e98', text: '#fff', domain: 'kkpfg.com' },
  { name: 'ธนาคารยูโอบี',            display: 'ยูโอบี',            short: 'UOB',       bg: '#e7231a', text: '#fff', domain: 'uob.com' },
  { name: 'ธนาคาร CIMB ไทย',         display: 'CIMB ไทย',          short: 'CIMB',      bg: '#c01324', text: '#fff', domain: 'cimb.com' },
  { name: 'ธนาคารแลนด์แอนด์เฮ้าส์', display: 'แลนด์แอนด์เฮ้าส์', short: 'LHB',      bg: '#0b6836', text: '#fff', domain: 'lhbank.co.th' },
  { name: 'ธนาคารอิสลาม',            display: 'อิสลาม',            short: 'IIB',       bg: '#156f3a', text: '#fff', domain: 'ibank.co.th' },
  { name: 'พร้อมเพย์',               display: 'พร้อมเพย์',        short: 'PP',        bg: '#7d3f8d', text: '#fff', domain: 'promptpay.io' },
];

// 'inspection_failed' is written by the ส่งตรวจ flow itself when an appraisal
// comes back ไม่ผ่าน — the order arrives in the cancel tab already carrying it,
// so the form pre-selects it rather than asking an admin to re-state what the
// system already knows. It ends the order like the four above it.
export const REASONS = [
  { value: 'cancelled',  label: 'สินค้ายกเลิก' },
  { value: 'damaged',    label: 'สินค้าเสียหาย' },
  { value: 'not_found',  label: 'หาของไม่เจอ' },
  { value: 'late_order', label: 'สั่งซื้อไม่ทัน' },
  { value: 'cannot_buy',    label: 'ซื้อไม่ได้' },
  { value: 'inspection_failed', label: 'ส่งตรวจไม่ผ่าน' },
  { value: 'admin_mistake', label: 'แอดมินสรุปผิด' },
  { value: 'other',         label: 'อื่นๆ' },
];

export const REASON_LABELS = Object.fromEntries(REASONS.map((r) => [r.value, r.label]));

// productPayment status → badge colors
export const PRODUCT_PAYMENT_STYLE = {
  'ชำระครบแล้ว': 'bg-green-50 text-green-700 border-green-200',
  'มัดจำ 50%':   'bg-orange-50 text-orange-700 border-orange-200',
  'รอชำระ':      'bg-gray-50 text-gray-500 border-gray-200',
  'คืนเงินแล้ว':  'bg-red-50 text-red-700 border-red-200',
};

// product payment states that mean the customer actually paid something refundable
export const PAID_STATUSES = ['ชำระครบแล้ว', 'มัดจำ 50%'];

export const BankBadge = ({ bankName }) => {
  const [imgErr, setImgErr] = useState(false);
  const bank = BANKS.find((b) => b.name === bankName);
  if (!bank) return <span>{bankName}</span>;
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className="inline-flex items-center justify-center rounded w-7 h-7 shrink-0 bg-white border border-gray-200 overflow-hidden">
        {!imgErr ? (
          <img
            src={`https://logo.clearbit.com/${bank.domain}`}
            alt={bank.display}
            className="w-6 h-6 object-contain"
            onError={() => setImgErr(true)}
          />
        ) : (
          <span className="w-7 h-7 rounded flex items-center justify-center text-xs font-bold"
            style={{ backgroundColor: bank.bg, color: bank.text }}>{bank.short.slice(0, 2)}</span>
        )}
      </span>
      <span>{bank.name}</span>
    </span>
  );
};

export const BankLogoButton = ({ bank, selected, onClick }) => {
  const [imgErr, setImgErr] = useState(false);
  return (
    <button type="button" onClick={onClick}
      className={`flex flex-col items-center p-2 rounded-lg border-2 transition-all text-center ${
        selected ? 'border-blue-500 shadow-md bg-blue-50' : 'border-gray-200 hover:border-gray-400 bg-white'
      }`}>
      <div className="w-10 h-10 rounded-lg bg-white border border-gray-100 flex items-center justify-center overflow-hidden mb-1">
        {!imgErr ? (
          <img
            src={`https://logo.clearbit.com/${bank.domain}`}
            alt={bank.display}
            className="w-8 h-8 object-contain"
            onError={() => setImgErr(true)}
          />
        ) : (
          <span className="w-10 h-10 rounded-lg flex items-center justify-center text-[10px] leading-none font-bold whitespace-nowrap px-0.5"
            style={{ backgroundColor: bank.bg, color: bank.text }}>{bank.short}</span>
        )}
      </div>
      <span className="text-xs leading-tight">{bank.display}</span>
    </button>
  );
};
